import React from 'react';
import { config } from '../config/';


function NotFoundPage() {
  return (
    <div className="u-flex-center-both u-padding-small u-padding-top u-text-center u-border-box">
      <div>
        <h1>404 NOT FOUND</h1>
        <div className="u-padding-bottom">
          <p>The page you are looking has either been moved, deleted or does not exist.</p>
          <h2>Where can you go from here?</h2>

          <div className="u-padding-bottom-small">
            <a href={config.URLS.SOFOLOGY_HOME}>Sofology Home</a>
          </div>
          <div>
            <a href="./">MySofology Home</a>
          </div>

        </div>

        <div>
          <div className="u-padding-bottom-tiny">If all else fails you can call us FREE</div>
          <div className="u-padding-bottom-tiny">Monday to Friday 8am to 6pm</div>
          <div className="u-padding-bottom-tiny">Saturday 9am to 5pm</div>

          <a href="tel:03444818181">03444 81 81 81</a>
        </div>

      </div>
    </div>
  );
}

export default NotFoundPage;



// WEBPACK FOOTER //
// ./src/pages/NotFoundPage.js